<template>
  <footer class="footer">
    <div
      :class="[
        'container d-flex justify-content-between py-4',
        isShortPage ? 'text-white' : '',
      ]"
    >
      <nav class="pull-left">
        <ul>
          <!-- <li class="nav-item">
	                <router-link class="nav-link text-nowrap" to="about">
	                  {{$t('message.menu.about')}}
	                </router-link>
	              </li>
                <li class="nav-item">
	                <router-link class="nav-link text-nowrap" to="project">
	                  {{$t('message.menu.project')}}
	                </router-link>
	              </li>
	              <li class="nav-item">
	                <router-link class="nav-link text-nowrap" to="management">
	                  {{$t('message.menu.board')}}
	                </router-link>
	              </li>
	              <li class="nav-item">
	                <a href="#" class="nav-link text-nowrap">
	                  {{$t('message.menu.services')}}
	                </a>
	              </li>
	              <li class="nav-item">
	                <router-link class="nav-link text-nowrap" to="contacts">
	                  {{$t('message.menu.contacts')}}
	                </router-link>
	              </li> -->
        </ul>
      </nav>
      <div class="copyright pull-right">© {{ year }}, Attis</div>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    year() {
      var d = new Date();
      return d.getFullYear();
    },
    isShortPage() {
      if (this.$route.name == "sign-in") {
        return true;
      }
      return false;
    },
  },
};
</script>
